<template src="../templates/filter-popup.html" />

<script setup>

import {
    computed, defineEmits, defineProps, ref, toRefs,
} from 'vue';

const emit = defineEmits(['update:selectedTerms']);

const props = defineProps({
    selectedCategory: {
        type: String,
        required: true,
    },
    selectedRegion: {
        type: String,
        required: true,
    },
    // eslint-disable-next-line
    selectedTerms: {
        type: Array,
    },
    categoriesFacets: {
        type: Array,
        required: true,
    },
    regionsFacets: {
        type: Array,
        required: true,
    },
    // eslint-disable-next-line
    taxonomyFilters: {
        type: Array,
    },
    totalResults: {
        type: Number,
        required: true,
    },
    clearFilters: {
        type: Function,
        required: true,
    },
});

const {
    selectedCategory,
    selectedRegion,
    selectedTerms,
    categoriesFacets,
    regionsFacets,
    taxonomyFilters,
    totalResults,
} = toRefs(props);

const isFiltersApplied = computed(() => {

    return selectedCategory.value
        || selectedRegion.value
        || (selectedTerms.value && Object.values(selectedTerms.value).length);

});

const clearSelectedFilters = () => {

    props.clearFilters();

};

const handleTermFilterChange = (typeID, termID) => {

    emit('update:taxonomyFilters', typeID, termID);

};

</script>
